<template>
  <div
    :class="[`kaer-goods-${type}`, isInKaer && !(goods || {}).itemId && 'error-box']"
    @click="goToGoodsDetail"
    v-if="isInKaer || (!isInKaer && goods.itemId)"
  >
    <div class="goods-img-wrap">
      <div
        class="goods-img"
        :style="{
          backgroundImage: `url(${
            goods.mainImg || 'http://static.91jkys.com/activity/img/b5f63778ed7146e4980604e1e4a622de.png'
          })`,
        }"
      />
      <div class="goods-mask"></div>
      <div class="goods-down-circle" v-if="goods.itemStatus === 1 || goods.stock === 0">已售罄</div>
      <div class="goods-tag" v-if="goods.itemType === 0">处方药</div>
    </div>
    <div class="goods-detail">
      <img alt="" class="active-tag" v-if="type === 'normal' && config && config.tag" :src="config.tag" />
      <!-- <div class="active-tag" v-if="type === 'normal' && config && config.tagText">
        <span
          class="active-tag-icon"
          v-if="config.tagIcon"
          :style="{backgroundImage: `url(${config.tagIcon})`}"
          ></span>
        {{ config.tagText }}
      </div> -->
      <div class="goods-title-wrap">
        <p class="goods-title">{{ goods.itemTitle }}</p>
        <p class="goods-subtitle" v-if="type === 'normal' || type === 'large'">{{ goods.spec }}</p>
      </div>
      <div class="goods-price-wrap">
        <template v-if="type === 'normal' || type === 'large'">
          <div class="new-price"><span class="price-unit">￥</span>{{ `${goods.sellingPrice || '0.00'}` }}</div>
          <div class="old-price" v-if="!goods.discountRate && showOriginalPrice(goods.sellingPrice, goods.originalPrice)">
            <span class="price-unit">￥</span>{{ `${goods.originalPrice || '0.00'}` }}
          </div>
          <discount-tag :rate="goods.discountRate" />
        </template>

        <template v-else>
          <div
            class="old-price"
            :style="{
              opacity: showOriginalPrice(goods.sellingPrice, goods.originalPrice) ? 1 : 0,
            }"
            v-if="!goods.discountRate"
          >
            <span class="price-unit">￥</span>{{ `${goods.originalPrice || '0.00'}` }}
          </div>
          <discount-tag :rate="goods.discountRate" />
          <div class="new-price"><span class="price-unit">￥</span>{{ `${goods.sellingPrice || '0.00'}` }}</div>
        </template>
      </div>
    </div>

    <!-- kaer 输入id查询不到提醒 -->
    <div class="error-msg" v-if="isInKaer && !(goods || {}).itemId">
      id: <span style="color: blue">{{ (goods || {}).queryId }}</span
      >不存在，请检查
    </div>
  </div>
</template>

<script>
import { staticUrl } from '@/config';
import { openUrl } from '@/utils/utils';
// import { uploadData } from '@/utils/uploadData';
import discountTag from '../discount-tag';

export default {
  name: 'goods',
  components: {
    discountTag,
  },
  props: {
    componentId: String,
    index: {
      type: Number,
      required: true,
    },
    clickTrackId: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'normal', // mini small normal large
    },
    goods: {
      type: Object,
      defautl: () => ({}),
    },
    config: {
      type: Object,
      defautl: () => ({}),
    },
  },
  computed: {
    isInKaer() {
      return top.location.href.indexOf('/web/kaer-admin') > -1;
    },
  },
  methods: {
    showOriginalPrice(sellingPrice, originalPrice) {
      // 售价小于原价 则显示原价
      return +sellingPrice < +originalPrice;
    },
    goToGoodsDetail() {
      if (!this.goods.itemCode) return;
      this.uploadData(this.clickTrackId, 'event', { itemCode: this.goods.itemCode, index: this.index, kaerComponentId: this.componentId });
      const baseUrl = `${staticUrl}f2e/zmall/#/detail/${this.goods.itemCode}`;
      openUrl(baseUrl, this);
    },
  },
};
</script>

<style lang="less" scoped>
@import './style/mini.less';
@import './style/small.less';
@import './style/normal.less';
@import './style/large.less';

.error-box {
  box-sizing: border-box;
  border: 3px solid red;
  position: relative;
  font-size: 16px;
  color: #fff;
  background: rgba(10 10 10 / 44%);
  text-align: center;
  .error-msg {
    display: block;
    position: absolute;
    top: 10%;
    background: red;
    white-space: normal;
    padding: 3px 10px;
    z-index: 99;
  }
}
</style>
